import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import { useNavigate } from 'react-router-dom';

export default function PurchaseDecisionModal({ isOpen, product, onClose, onConfirm }) {
  const navigate = useNavigate();
  if (!product) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-end md:items-center justify-center p-4"
          style={{ background: 'rgba(2,6,23,0.85)', backdropFilter: 'blur(8px)' }}
        >
          <motion.div
            initial={{ scale: 0.95, y: 40 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.95, y: 40 }}
            className="w-full max-w-md rounded-2xl overflow-hidden"
            style={{ background: 'rgba(15,23,42,0.98)', border: '1px solid rgba(6,182,212,0.2)' }}
          >
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-heading font-bold text-lg text-slate-50">Purchase Decision</h3>
                <button onClick={onClose} className="p-2 rounded-lg hover:bg-slate-800 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center">
                  <Icon name="X" size={18} color="#94A3B8" />
                </button>
              </div>

              <div className="bg-slate-800/60 rounded-xl p-4 mb-4">
                <p className="text-slate-300 text-sm mb-1">{product?.name}</p>
                <span className="font-data text-2xl font-bold text-cyan-400">${product?.price?.toFixed(2)}</span>
              </div>

              <p className="text-slate-400 text-sm mb-5">
                This purchase will be logged and deducted from your <span className="text-cyan-400">{product?.category || 'Shopping'}</span> budget category.
              </p>

              <div className="space-y-3">
                <Button variant="default" size="lg" fullWidth iconName="CheckCircle" iconPosition="left" onClick={onConfirm}>
                  Confirm Purchase
                </Button>
                <Button variant="outline" size="lg" fullWidth iconName="Settings2" iconPosition="left" onClick={() => navigate('/home-dashboard')}>
                  Adjust Budget First
                </Button>
                <Button variant="ghost" size="default" fullWidth onClick={onClose}>
                  Cancel
                </Button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}